import { Component, OnInit, Input } from '@angular/core';
import { GlobalConstants } from '../../constants/global.constant';
import { QrCodeService } from '../../../core/services/qr-input-service/qr-input.service';

@Component({
  selector: 'app-processor-page',
  templateUrl: './processor-page.component.html',
  styleUrls: ['./processor-page.component.css']
})
export class ProcessorPageComponent implements OnInit {
  @Input() panelData: any;
  ptlPanel = GlobalConstants.PTL_TILE_PANEL;
  isWhiteText= ['ptl_aiExperience', 'ptl_gaming', 'ptl_compatibility'];
  isPtl12Xe: boolean = false;
  setFontIntelDisplayOne: boolean;

  constructor(
    private qrService: QrCodeService
  ) { }

  ngOnInit(): void {
    this.isPtl12Xe = GlobalConstants.PANTHER_LAKE_12XE_BADGES.includes(this.qrService.qrInput.ProcessorBadge);
    this.setFontIntelDisplayOne = this.qrService.setenusLang();    
  }

  whiteText(imgUrl: string): string {
    return this.isWhiteText.some(word => imgUrl.includes(word)) ? 'white_color' : '';
  }

}
